import React from 'react';
import './Header.css';

const Header = ({ currentUser, showUserMenu, setShowUserMenu, onLogout }) => {
  return (
    <div className="top-header">
      <div className="header-left-section">
        <div className="header-logo">
          <img src="/transtar-logo.png" alt="Transtar" style={{height: '24px', width: 'auto'}} />
        </div>
        <div className="header-search">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <circle cx="11" cy="11" r="8"/>
            <path d="m21 21-4.35-4.35"/>
          </svg>
          <input type="text" placeholder="Search resources, services, and docs (Ctrl+/)" />
        </div>
      </div>
      <div className="header-right-section">
        <button className="header-action">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
            <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
          </svg>
          <span>Notifications</span>
          <span className="notification-badge"></span>
        </button>
        <div className="user-menu-container" onClick={() => setShowUserMenu(!showUserMenu)}>
          <div className="user-avatar">{currentUser?.email?.[0]?.toUpperCase() || 'U'}</div>
          <div className="user-info">
            <span className="user-name">{currentUser?.email?.split('@')[0] || 'User'}</span>
            <span className="user-role">Administrator</span>
          </div>
        </div>
        {showUserMenu && (
          <div className="user-dropdown-menu">
            <button className="user-menu-item" onClick={() => window.location.href = '/dashboard/settings'}>
              Settings
            </button>
            <button className="user-menu-item" onClick={onLogout}>
              Sign Out
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
